import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import withRouter from 'umi/withRouter';
import { Col, Row } from 'antd';

const GoBackOtherIcon = props => {
  return (
    <ArrowLeftOutlined
      style={{ cursor: 'pointer', display: 'inline', color: 'rgba(0, 0, 0, 0.5)' }}
      onClick={() => props.history.goBack()}
    />
  );
};
export default withRouter(GoBackOtherIcon);
